document.addEventListener("click", (event) => {
	if (event.target.closest(".aufgabeelement")) {
		const aufgabenelement = event.target.closest(".aufgabeelement"),
			aufgabenelemente = document.querySelectorAll(".aufgabeelement")

		aufgabenelemente.forEach((element) => {
			element.classList.remove("bg-spotlight", "text-white")
		})

		aufgabenelement.classList.add("bg-spotlight", "text-white")
	}
})
